import { ZariContext } from '_zari/context'
import { Portlet, Table } from '_zari/core'
import { EstadosTituloViaticos } from 'constants/index'
import React from 'react'
import * as UsuarioService from 'services/usuario.service'
import { ZrSwal } from 'utils'
import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Trabajador - Titulos Viaticos' }]

const tableHeaderRows = [
  { label: 'CODIGO' },
  { label: 'TITULO' },
  { label: 'ESTADO' },
  { label: '', width: 60 }
]

const TrabajadorTituloViaticoPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarInsertarActualizarModal, setMostrarInsertarActualizarModal] = React.useState(false)

  const tablaRef = React.useRef(null)
  const editarDataRef = React.useRef({})

  const clickEditar = React.useCallback(
    id => {
      UsuarioService.obtenerTituloViaticoxIdAsEdicion(id)
        .then(({ data }) => {
          editarDataRef.current = data
          setMostrarInsertarActualizarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickNuevo = React.useCallback(() => {
    editarDataRef.current = {}
    setMostrarInsertarActualizarModal(true)
  }, [])

  const clickEliminar = React.useCallback(
    id => {
      ZrSwal.showAlert({
        tipo: 'error',
        mensaje: 'Seguro que desea eliminar el registro?',
        showCerrar: true,
        onSuccess: () => {
          UsuarioService.eliminarTituloViaticoxId(id)
            .then(() => {
              __zariContext.snack('success', 'Registro eliminado!')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  const rowTemplate = React.useCallback(
    row => {
      if (!row) return null // Protección extra
      console.log('Fila recibida:', row) // Depuración temporal

      return (
        <Table.Row hover key={row._id || Math.random()}>
          <Table.Cell>{row?.codigo ?? '--'}</Table.Cell>
          <Table.Cell>{row?.nombre ?? '--'}</Table.Cell>
          <Table.Cell>
            {row?.estado
              ? EstadosTituloViaticos.__dictionary[row.estado]?.nombre ?? '--'
              : '--'}
          </Table.Cell>
          <Table.Cell>
            <Table.Dropdown>
              {({ handleClose }) => [
                <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={() => clickEditar(row._id)}>
                  Editar
                </Table.Dropdown.Item>,
                <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={() => clickEliminar(row._id)}>
                  Eliminar
                </Table.Dropdown.Item>
              ]}
            </Table.Dropdown>
          </Table.Cell>
        </Table.Row>
      )
    },
    [clickEditar, clickEliminar]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Trabajador - Titulos Viaticos'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
        />
        <Portlet.Body>
          <Table.ServerSide
            useNest={true}
            ref={tablaRef}
            url='/socios/titulos-viaticos-trabajador-general'
            headRows={tableHeaderRows}
            rowTemplate={rowTemplate}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarInsertarActualizarModal && (
        <Modals.InsertarActualizarModal
          show={mostrarInsertarActualizarModal}
          handleClose={() => setMostrarInsertarActualizarModal(false)}
          editarData={editarDataRef.current}
          reloadTable={tablaRef.current.reload}
        />
      )}
    </>
  )
}

export default React.memo(TrabajadorTituloViaticoPage)
